import { esusApi } from "@/services/api";

export type ResumeIndicatorB1Params = {
	uf: string;
	ibgeCode: string;
	quarter: string;
	year: number;
	month: number;
	ine?: string;
};

export class ResumeIndicatorB1Data {
	totalCitizensFinishedLinked: number = 0;
	totalCitizensFinished: number = 0;
	totalCitizens: number = 0;
}

export async function getResumeIndicatorB1({ uf, ibgeCode, ...params }: ResumeIndicatorB1Params) {
	const response = await esusApi.get<ResumeIndicatorB1Data>(
		`/uf/${uf}/city/${ibgeCode}/indicator/esb/b1/resume`,
		params
	);
	return response.data || new ResumeIndicatorB1Data();
}
